import { createContext } from "react";

import { INormSummary } from "@/shared/services/norms/norms-http.service";
import { ITestAnswerTimes } from "@/shared/components/charts/types/chartTypes";
import { ITestChoice } from "@/shared/components/candidate/scenes/TestElement/TestElement";
import { ITestScoreResponse } from "@/shared/components/assessment/service/computeTest.service";

export type TTestAnalysisAnswers = {
  testId: number;
  normId: number;
  answers: ITestChoice[];
  times: ITestAnswerTimes | null;
};

export type TAnalysisContext = {
  initialTestAnswers: TTestAnalysisAnswers[];
  updatedTestsAnswers: TTestAnalysisAnswers[];
  testResults: ITestScoreResponse[];
  normsMap: { [testId: number]: INormSummary[] };
  setUpdatedTestsAnswers?: React.Dispatch<React.SetStateAction<TTestAnalysisAnswers[]>>;
  setHasChangedElements?: React.Dispatch<React.SetStateAction<boolean>>;
};

export const AnalysisContext = createContext<TAnalysisContext>({
  initialTestAnswers: [],
  updatedTestsAnswers: [],
  testResults: [],
  normsMap: {},
});
